// Google Analytics 4 helper — wraps gtag for SPA route tracking + custom events
// Loaded once in index.html. This module provides a clean API.

const GA_MEASUREMENT_ID = 'G-8Q7KB6WSHE';

const isAvailable = () => typeof window !== 'undefined' && typeof window.gtag === 'function';

// Send a page_view manually (SPA route changes don't trigger gtag automatically when send_page_view:false)
export const trackPageView = (path, title) => {
  if (!isAvailable()) return;
  window.gtag('event', 'page_view', {
    page_path: path,
    page_title: title || document.title,
    page_location: window.location.href,
    send_to: GA_MEASUREMENT_ID,
  });
};

// Generic event tracker
export const trackEvent = (eventName, params = {}) => {
  if (!isAvailable()) return;
  window.gtag('event', eventName, { ...params, send_to: GA_MEASUREMENT_ID });
};

// Pre-defined business events
export const analytics = {
  // Auth
  signupStarted: (role) => trackEvent('signup_started', { role }),
  signupCompleted: (role) => trackEvent('sign_up', { method: 'phone', role }),
  loginCompleted: (method) => trackEvent('login', { method }),
  otpRequested: (channel) => trackEvent('otp_requested', { channel }), // whatsapp / sms

  // Search
  searchPerformed: (query, role, location) =>
    trackEvent('search', { search_term: query, role, location }),
  providerViewed: (providerId, role) =>
    trackEvent('view_provider', { provider_id: providerId, role }),

  // Booking funnel
  bookingStarted: (providerId, serviceType) =>
    trackEvent('begin_checkout', { provider_id: providerId, service_type: serviceType }),
  bookingCompleted: (appointmentId, fee, serviceType) =>
    trackEvent('purchase', {
      transaction_id: appointmentId,
      value: fee,
      currency: 'INR',
      service_type: serviceType,
    }),

  // Provider/Clinic actions
  providerProfileUpdated: () => trackEvent('provider_profile_updated'),
  clinicMemberAdded: (role) => trackEvent('clinic_member_added', { role }),
  availabilityToggled: (active) => trackEvent('availability_toggled', { active }),
};

// Set user ID once they log in (helps with cross-device tracking)
export const setUserId = (userId, role) => {
  if (!isAvailable()) return;
  window.gtag('config', GA_MEASUREMENT_ID, { user_id: userId });
  if (role) {
    window.gtag('set', 'user_properties', { user_role: role });
  }
};

export default analytics;
